module.exports = __webpack_public_path__ + "img/48ab3e6.jpg";